export default __webpack_public_path__ + "static/media/earth-dark.9aaf0c40.jpg";